import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-507f805e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "area-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title flow-title" }, "資料を一括送信", -1))
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" エクセル形式のテンプレートを使用してメタデータを入力していただき、資料のファイルと併せて圧縮してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" この圧縮ファイルをアップロードしていただくことで、複数の資料をまとめて送信できます。 ")
], -1))
const _hoisted_6 = { class: "content has-background-contents shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StopSend = _resolveComponent("StopSend")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OuterFileInput = _resolveComponent("OuterFileInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_StopSend)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Breadcrumb, {
        list: _ctx.list,
        pageNum: 1
      }, null, 8, ["list"])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_OuterFileInput)
    ])
  ]))
}